<template>
  <div class="image-wrapper-component">
    <button
      v-if="canDelete"
      class="delete-button"
      @click="handleDelete"
      v-title="deleteTitle">
      <i class="material-symbols-outlined">close</i>
    </button>

    <ImageUploaderV2
      :id="uploaderId"
      :title="uploaderTitle"
      :imageProps="imageProps"
      :context="context"
      :menuOptions="menuOptions"
      @resetAutoStartUpload="$emit('resetAutoStartUpload')"
      @submenu-action="$emit('submenu-action', $event)"
      :disableMenus="disableMenus" />
  </div>
</template>

<script>
import ImageUploaderV2 from '../image/ImageUploaderV2.vue'

export default {
  name: 'ImageWrapper',
  components: {
    ImageUploaderV2
  },
  props: {
    uploaderId: {
      type: String,
      required: true
    },
    uploaderTitle: {
      type: String,
      default: ''
    },
    imageProps: {
      type: Object,
      required: true
    },
    context: {
      type: String,
      default: 'questions'
    },
    menuOptions: {
      type: Array,
      default: () => []
    },
    disableMenus: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    deleteTitle: {
      type: String,
      default: 'Delete image'
    }
  },
  methods: {
    handleDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper-component {
  position: relative;
  width: 100%;
  height: 100%;

  .delete-button {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: white;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    opacity: 0;
    transform: scale(0.8);

    i {
      font-size: 18px;
      color: var(--accent-color, #ff607d);
    }

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }
  }

  &:hover .delete-button {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
